export const COMMIT_HASH = '0698c37b70ca4cc0cad06bcc5582fdb8a5b44970';
